import React from "react";
import { Outlet, useParams } from "react-router-dom";

const ArtistPage: React.FC = () => {

  const { artistId } = useParams<string>();

  if (!artistId){
    return (<h1>Artist not found in client</h1>);
  }

  return (
    <>
    <Outlet />
    {/* <ArtistLanding /> */}
    </>
  )
 };

export default ArtistPage;
